module.exports = __webpack_public_path__ + "static/media/ndi-banner.98da09ed.gif";